const apiHost = process.env.API_HOST;

export default apiHost;
